import { notifications } from '@mantine/notifications';

export const toast = {
  success: (message: string) => notifications.show({ message, color: 'green' }),
  error: (message: string) => notifications.show({ message, color: 'red' }),
  warning: (message: string) => notifications.show({ message, color: 'yellow' }),
  info: (message: string) => notifications.show({ message, color: 'blue' }),
};
